module.exports = __webpack_public_path__ + "static/三方盒子（WJY、LZY）刷机教程v1.61311.1133b589.png";